// @ts-nocheck
import React, { useState, useEffect } from "react";
import { Emit_main } from "../navigation";
import * as C from "../controls"
import * as P from "../program-state"
import {IconProp} from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowUpRightFromSquare, faCheck, faExternalLink, IconDefinition, faCircleChevronLeft, faCircleChevronRight } from "@fortawesome/free-solid-svg-icons"
import { faFacebook, faLinkedin, faTiktok, faXTwitter } from "@fortawesome/free-brands-svg-icons"
import { connected_network } from "../program-state"
import { Link } from "react-router-dom"
import YouTube from 'react-youtube';
import { z } from "zod"
// reuse from connected-networks.tsx
import { find, is_network, network_card_or_loading, still_loading, cn_to_edit_href, netinfo } from "./connected-networks"
// reuse from connected-networks-individual-editor
import { Memo_view as Individual_network_editor } from "./connected-networks-individual-editor";
import { Meta_pixel_instruction, Linkedin_insight_tag_instruction, Tiktok_pixel_instruction } from "./network-instructions"
// reuse from brands.tsx
import { Emit_active_networks_icon } from "./brands"
// reuse from brand create
import * as Bie from "./brands-individual-editor"
import { StepData, Substep, useOnboardingContext, OnboardingContextProvider, Onboarding_context_type } from "./wizard-provider";
// reuse from audiences-create.tsx
import { Create_audience_form } from "./audiences-create";
import { display_brand_name, display_network_on_audience, display_estimated_audience_range } from "./audiences";
import {display_network_on_custom_audience} from "./custom-audiences";
// reuse from campaigns-create
import { Create_campaign_form } from "./campaigns-create"
import MqttInitializer from "./mqtt/mqtt_initializer"
import { MultistepCreateCampaignProvider } from "./campaigns/campaign_create_provider"
// reuse from custom-audience-create
import { Create_custom_audience_form } from "./custom-audience-create"
import { audience_t, brand_t, custom_audience_t } from "@/resource/types";


/******************************************************************************
 ** Step 1.1 Oauth integration [
 ******************************************************************************/
const oauth_redirect_response = z.object({
    type : z.string(),
    uri : z.string()
})

const basic_card_style = "tw-flex tw-flex-col tw-gap-3"
const card_border_style = "tw-border tw-border-dashed"

const get_oauth_link = async (ps : P.program_state, us : P.user_state, network : string) => {
    const url = P.v1api`oauth/initialize-${network}-oauth?redirect=false`
    console.log("url: ", url, ", token: ", us.token)
    const [rok, rval] = await P.issue_json_get(url, oauth_redirect_response, us.token)
    if (rok) {
        console.log("success: ", rval)
    } else {
        console.log("error: ", rval)
    }
    return rval.uri
}

const Add_network_block = ({display_name = "facebook", icon = faFacebook}: {display_name : string, icon : IconDefinition}) => {
    const [connected_networks, ps, us] = P.use_connected_networks()
    const [oauth_url, set_oauth_url] = useState<string>("")

    P.run_once_on_component_creation(() => {
        get_oauth_link(ps, us, display_name).then((url) => {
            set_oauth_url(url)
        })
    })

    const on_oauth_click = (e: React.MouseEvent) => {
        if (display_name.toLowerCase() === "x") {
            sessionStorage.setItem('x_oauth_pending', 'true')
        }
        const width = 900;
        const height = 720;
        const left = (window.screen.width - width) / 2;
        const top = (window.screen.height - height) / 2;
        window.open(oauth_url, '_blank', `location=yes, height=${height}, width=${width}, left=${left}, top=${top}, scrollbars=yes, status=yes`);
        e.preventDefault()
    }

    return (
        <a href={oauth_url} onClick={on_oauth_click}>
        <div className={`${basic_card_style} ${card_border_style} tw-flex tw-text-center tw-rounded tw-justify-center hover:tw-bg-gray-50 tw-cursor-pointer tw-p-2`}>
            <div>
                <FontAwesomeIcon icon={icon} className="tw-h-6" aria-hidden="true"/>
                <p>Add {display_name} account</p>
            </div>
            <div className="tw-my-auto">
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} aria-hidden="true" className="tw-ps-1.5"/>
            </div>
        </div>
        </a>
    )
}

const Network_account_block = ({network}: {network : connected_network}) => {
    const edit_url = cn_to_edit_href(network)

    return (
        <Link to={edit_url} target="_blank" rel="noopener noreferrer">
        <div className="tw-flex tw-item-centers tw-border tw-p-2 tw-justify-between">
            <div>
                <C.Eres_headerlg>{network.name}</C.Eres_headerlg>
                <p className="tw-text-sm">Account ID: {network?.network_account_id}</p>
                <p className="tw-text-sm">Status: Connected</p>
            </div>
            <div className="tw-my-auto">
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} aria-hidden="true" className="tw-ps-1.5"/>
            </div>
        </div>
        </Link>
    )
}

const Social_network_integration_block = ({ network_name, icon, data } : { network_name : string, icon : IconProp, data : network_card_or_loading }) => {
    const [dtag, _data] = data;

    switch (dtag) {
        case "loading":
            return (
                <div className={`${basic_card_style} ${card_border_style}`}>
                    <C.Eres_spin_placeholder className="tw-p-6" />
                </div>
            );
        case "ncard": {
            const { network, token, netinfo } = _data;
            const [ok, ni] = netinfo;
            if (ok && ni.network_tag === network) {
                let network_name_proper = network_name.charAt(0).toUpperCase() + network_name.slice(1);
                return (
                    <div className="tw-flex tw-flex-col tw-space-y-2">
                        <p>{`Congratulations, your ${network_name_proper} account is connected.`}</p>
                        <Network_account_block network={ni} />
                    </div>
                );
            } else {
                let connectMessage = `You haven't connected a ${network_name} account. Please press the button below to give permissions.`;

                if (network_name.toLowerCase() === "facebook") {
                    connectMessage = `Authorize a Meta account to manage business managers, ad accounts, pages, instagram profiles, and pixels. Click below to connect and enable ad publishing on our platform.`;
                } else if (network_name.toLowerCase() === "linkedin") {
                    connectMessage = `Connect a LinkedIn account to manage companies, ad accounts, insight tags, and conversions. Click below to grant permissions and start publishing ads through our platform.`;
                } else if (network_name.toLowerCase() === "tiktok") {
                    connectMessage = `Link a TikTok account to manage business centers, ad accounts, identities, and pixels. Click below to connect your account and enable ad publishing on our platform.`;
                } else if (network_name.toLowerCase() === "x") {
                    connectMessage = `Connect an X (Twitter) account to manage ad accounts, Web Event Tags, and promote tweets. Click below to authorize access and enable ad publishing on our platform.`;
                }

                return (
                    <div className="tw-flex tw-flex-col tw-space-y-2">
                        <p>{connectMessage}</p>
                        <Add_network_block display_name={network_name} icon={icon} />
                    </div>
                );
            }
        }
    }
};


export const Oauth_integration_step = () => {
    const [ state, dispatch ] = useOnboardingContext();
    const [connected_networks, ps, us] = P.use_connected_networks()
    const [is_polling_x_oauth, set_is_polling_x_oauth] = useState(false)
    P.run_once_on_component_creation(() => void P.poll_connected_networks(ps, us))

    let fbnet : network_card_or_loading = still_loading
    let linet : network_card_or_loading = still_loading
    let ttnet : network_card_or_loading = still_loading
    let xnet : network_card_or_loading = still_loading

    // check if we're returning from x oauth and poll for connection
    useEffect(() => {
        const x_oauth_pending = sessionStorage.getItem('x_oauth_pending')

        if (x_oauth_pending === 'true' && !is_polling_x_oauth) {
            set_is_polling_x_oauth(true)

            // poll for x connection
            const poll_x_connection = async () => {
                const max_attempts = 30  
                const poll_interval = 1000 

                for (let attempt = 0; attempt < max_attempts; attempt++) {
                    const [ok, data] = await P.issue_json_get(
                        P.v1api`social/x/users`,
                        z.array(z.object({
                            id : z.number(),
                            x_id : z.string(),
                            screen_name : z.string(),
                        })),
                        us.token
                    )

                    if (ok && data && data.length > 0) {
                        // connection successful, refresh networks and clear flag
                        sessionStorage.removeItem('x_oauth_pending')
                        await P.poll_connected_networks(ps, us)
                        set_is_polling_x_oauth(false)
                        return
                    }

                    // wait before next poll
                    await new Promise(resolve => setTimeout(resolve, poll_interval))
                }

                // polling timed out
                console.log("X OAuth polling timed out")
                sessionStorage.removeItem('x_oauth_pending')
                set_is_polling_x_oauth(false)
            }

            void poll_x_connection()
        }
    }, [us.token, ps, us, is_polling_x_oauth])

    useEffect(() => {
        if (connected_networks !== undefined && connected_networks.length > 0) {
            dispatch({type: "MARK_STEP_COMPLETE", payload: {step_id: "step1", substep_id: "substep11"}})
        } else {
            dispatch({type: "MARK_STEP_INCOMPLETE", payload: {step_id: "step1", substep_id: "substep11"}})
        }
    }, [connected_networks, dispatch])

    if (connected_networks !== undefined) {
        const fbnet_info = find(connected_networks, is_network("nw-facebook"))
        const linet_info = find(connected_networks, is_network("nw-linkedin"))
        const ttnet_info = find(connected_networks, is_network("nw-tiktok"))
        const xnet_info = find(connected_networks, is_network("nw-x"))
        fbnet = ["ncard", {network : "nw-facebook", token : us.token, netinfo : fbnet_info}]
        linet = ["ncard", {network : "nw-linkedin", token : us.token, netinfo : linet_info}]
        ttnet = ["ncard", {network : "nw-tiktok", token : us.token, netinfo : ttnet_info}]
        xnet = ["ncard", {network : "nw-x", token : us.token, netinfo : xnet_info}]
    }

    return (
        <C.Eres_card className="tw-overflow-x-auto">
            <div className="tw-m-2 md:tw-m-3">
                <div className="tw-h-auto">
                    <C.Eres_header2xl className="tw-mb-2">Oauth integration</C.Eres_header2xl>
                    <C.Eres_hline className="tw-m-3" />
                    <C.Eres_headerlg>Facebook</C.Eres_headerlg>
                    <Social_network_integration_block network_name="facebook" icon={faFacebook} data={fbnet} />

                    <C.Eres_hline className="tw-m-3" />

                    <C.Eres_headerlg>Linkedin</C.Eres_headerlg>
                    <Social_network_integration_block network_name="linkedin" icon={faLinkedin} data={linet} />

                    <div className="tw-m-3">
                        <C.Eres_hline />
                    </div>
                    <C.Eres_headerlg>Tiktok</C.Eres_headerlg>
                    <Social_network_integration_block network_name="tiktok" icon={faTiktok} data={ttnet} />

                    <div className="tw-m-3">
                        <C.Eres_hline />
                    </div>
                    <C.Eres_headerlg>X (Twitter)</C.Eres_headerlg>
                    <Social_network_integration_block network_name="x" icon={faXTwitter} data={xnet} />
                </div>
            </div>
        </C.Eres_card>
    )
}

/******************************************************************************
 ** Step 1.1 Oauth integration ]
 ******************************************************************************/


/******************************************************************************
 ** Step 1.2 Asset syncing and verification [
 ******************************************************************************/
const Require_connect = ({text} : {text : string}) => {
    const [ _, dispatch ] = useOnboardingContext();

    const on_go_to_step1_click = () => {
        dispatch({type: "SET_ACTIVE_STEP", payload: "substep11"})
    }

    return (
        <C.Eres_card className="tw-overflow-x-auto">
            <div className="tw-flex tw-flex-col tw-item-centers tw-border tw-p-2 tw-space-y-2">
                <p>{`${text} is not connected. Authorize your account in order to grant the permissions required to publish ads.`}</p>
                <p>Click below to go back to the previous step.</p>
                <C.Eres_iconbutton icon={faExternalLink} onClick={on_go_to_step1_click} >Previous step</C.Eres_iconbutton>
            </div>
        </C.Eres_card>
    )
}

const Facebook_assets_part = ({item} : {item : netinfo}) => {
    switch (item) {
        case undefined: return (
            <div className={`${basic_card_style} ${card_border_style}`}>
                <C.Eres_spin_placeholder className="tw-p-6"/>
            </div>
        )
        default: {
            const [Ok, ni] = item
            const [ps, cs] = P.use_authenticated_program_state()
            return Ok ? <Individual_network_editor prefixed_dbid={`fb-${ni.eres_dbid}`} program_state={ps} user_state={cs}/> : <Require_connect text="Facebook" />
        }
    }
}


const Linkedin_assets_part = ({item} : {item : netinfo}) => {
    switch (item) {
        case undefined: return (
            <div className={`${basic_card_style} ${card_border_style}`}>
                <C.Eres_spin_placeholder className="tw-p-6"/>
            </div>
        )
        default: {
            const [Ok, ni] = item
            const [ps, cs] = P.use_authenticated_program_state()
            return Ok ? <Individual_network_editor prefixed_dbid={`li-${ni.eres_dbid}`} program_state={ps} user_state={cs}/> : <Require_connect text="Linkedin" />
        }
    }
}


const Tiktok_assets_part = ({item} : {item : netinfo}) => {
    switch (item) {
        case undefined: return (
            <div className={`${basic_card_style} ${card_border_style}`}>
                <C.Eres_spin_placeholder className="tw-p-6"/>
            </div>
        )
        default: {
            const [Ok, ni] = item
            const [ps, cs] = P.use_authenticated_program_state()
            return Ok ? <Individual_network_editor prefixed_dbid={`tt-${ni.eres_dbid}`} program_state={ps} user_state={cs}/> : <Require_connect text="Tiktok" />
        }
    }
}


export const Asset_syncing_and_verification_step = () => {
    const [ state, dispatch ] = useOnboardingContext();
    const [connected_networks, ps, us] = P.use_connected_networks()
    P.run_once_on_component_creation(() => void P.poll_connected_networks(ps, us))

    let fbnet_info : netinfo = undefined
    let linet_info : netinfo = undefined
    let ttnet_info : netinfo = undefined


    useEffect(() => {
        if (connected_networks !== undefined) {
            fbnet_info = find(connected_networks, is_network("nw-facebook"))
            linet_info = find(connected_networks, is_network("nw-linkedin"))
            ttnet_info = find(connected_networks, is_network("nw-tiktok"))

            const [fbok, fbni] = fbnet_info
            const [liok, lini] = linet_info
            const [ttok, ttin] = ttnet_info

            // if either fbok, liok, ttok is true, then the step is complete
            if (fbok || liok || ttok) {
                dispatch({type: "MARK_STEP_COMPLETE", payload: {step_id: "step1", substep_id: "substep12"}})
            } else {
                dispatch({type: "MARK_STEP_INCOMPLETE", payload: {step_id: "step1", substep_id: "substep12"}})
            }
        }
    }, [connected_networks, dispatch])

    if (connected_networks !== undefined) {
        fbnet_info = find(connected_networks, is_network("nw-facebook"))
        linet_info = find(connected_networks, is_network("nw-linkedin"))
        ttnet_info = find(connected_networks, is_network("nw-tiktok"))
    }

    return (
        <C.Eres_card className="tw-overflow-x-auto">
            <div className="tw-m-2 md:tw-m-3">
                <div className="tw-h-auto">
                    <C.Eres_header2xl className="tw-mb-2">Asset syncing and verification</C.Eres_header2xl>
                    <C.Eres_hline className="tw-m-3" />
                    <div className="tw-mb-8">
                        <C.Eres_headerlg className="tw-mb-3">Facebook</C.Eres_headerlg>
                        <div className="tw-ml-2 md:tw-ml-6 tw-overflow-x-auto">
                            <Facebook_assets_part item={fbnet_info} />
                        </div>
                    </div>
                    <C.Eres_hline />
                    <div className="tw-my-8">
                        <C.Eres_headerlg className="tw-mb-3">LinkedIn</C.Eres_headerlg>
                        <div className="tw-ml-2 md:tw-ml-6 tw-overflow-x-auto">
                            <Linkedin_assets_part item={linet_info} />
                        </div>
                    </div>
                    <C.Eres_hline />
                    <div className="tw-my-6">
                        <C.Eres_headerlg className="tw-mb-3">Tiktok</C.Eres_headerlg>
                        <div className="tw-ml-2 md:tw-ml-6 tw-overflow-x-auto">
                            <Tiktok_assets_part item={ttnet_info} />
                        </div>
                    </div>
                </div>
            </div>
        </C.Eres_card>
    )
}

/******************************************************************************
 ** Step 1.2 Asset syncing and verification ]
 ******************************************************************************/


/******************************************************************************
 ** Step 3.1 Brand creation [
 ******************************************************************************/
const Show_lastest_brand_block = ({brand}: {brand : brand_t}) => {
    const detail_url = `/brands/${brand.id}/`

    return (
        <Link to={detail_url} target="_blank" rel="noopener noreferrer">
        <div className="tw-flex tw-items-center tw-border tw-p-2 tw-justify-between tw-gap-2 tw-min-w-0">
            <div className="tw-min-w-0 tw-flex-1">
                <C.Eres_headerlg className="tw-truncate">{brand.name}</C.Eres_headerlg>
                <div className="tw-flex tw-flex-wrap tw-gap-x-2 tw-gap-y-1 tw-items-center">
                    <p className="tw-text-sm tw-whitespace-nowrap">Associated Networks: </p>
                    {Emit_active_networks_icon(brand)}
                </div>
            </div>
            <div className="tw-shrink-0">
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} aria-hidden="true" className="tw-ps-1.5"/>
            </div>
        </div>
        </Link>
    )
}


export const Brand_creation_component = () => {
    const [ _, dispatch ] = useOnboardingContext();
    P.run_once_on_component_creation(() => void P.poll_connected_brands(ps, cs))
    const [brands, ps, cs] = P.use_brands()

    useEffect(() => {
        if (brands?.length) {
            dispatch({type: "MARK_STEP_COMPLETE", payload: {step_id: "step3", substep_id: "substep31"}})
        } else {
            dispatch({type: "MARK_STEP_INCOMPLETE", payload: {step_id: "step3", substep_id: "substep31"}})
        }
    }, [brands, dispatch])

    const render_brand_already_created = () => {
        return (<div className="tw-w-full tw-h-128 tw-space-y-2">
            <p>Congratulation, you have created a brand</p>
            <div className="tw-flex tw-flex-col tw-space-y-2">
                <Show_lastest_brand_block brand={brands[0]} />
                { brands.length > 1 ?
                    <Link to="/brands/" className="tw-text-blue-600" target="_blank" rel="noopener noreferrer">
                        View all created brands <FontAwesomeIcon icon={faExternalLink} className="tw-me-2" aria-hidden="true"/>
                    </Link> : null
                }
            </div>
        </div>)
    }

    return (
        <C.Eres_card className="tw-overflow-x-auto">
            <div className="tw-m-2 md:tw-m-3">
                <C.Eres_header2xl>Brand Creation</C.Eres_header2xl>
                <C.Eres_hline className="tw-m-3" />
                <div className="tw-h-min">
                    { brands !== undefined && brands.length > 0 ? render_brand_already_created() : <Bie.Brand_editor brand_id={{tag : "create-brand"}} /> }
                </div>
            </div>
        </C.Eres_card>
    )
}

/******************************************************************************
 ** Step 3.1 Brand creation ]
 ******************************************************************************/


/******************************************************************************
** Step 4 Audience creation [
******************************************************************************/

const Show_lastest_custom_audience_block = ({audience}: {audience : custom_audience_t}) => {
    const [brands, ps, cs] = P.use_brands()
    const detail_url = `/custom-audiences/${audience.id}/`

    return (
        <Link to={detail_url} target="_blank" rel="noopener noreferrer">
            <div className="tw-flex tw-items-center tw-border tw-p-2 tw-justify-between tw-gap-2 tw-min-w-0">
                <div className="tw-space-y-0.5 tw-min-w-0 tw-flex-1">
                    <C.Eres_headerlg className="tw-truncate">{audience.name}</C.Eres_headerlg>
                    <p className="tw-text-sm tw-truncate">Associated brand: <span className="tw-font-semibold">{display_brand_name(brands, audience)}</span></p>
                    <div className="tw-flex tw-flex-wrap tw-gap-x-2 tw-gap-y-1 tw-items-center">
                        <p className="tw-text-sm tw-whitespace-nowrap">Networks: </p>
                        {display_network_on_custom_audience(audience)}
                    </div>
                </div>
                <div className="tw-shrink-0">
                    <FontAwesomeIcon icon={faArrowUpRightFromSquare} aria-hidden="true" className="tw-ps-1.5"/>
                </div>
            </div>
        </Link>
    )
}


const Custom_audience_creation_component = () => {
    const [ _, dispatch ] = useOnboardingContext();
    P.run_once_on_component_creation(() => void P.poll_custom_audiences(ps, cs))
    const [custom_audiences, ps, cs] = P.use_custom_audiences()

    useEffect(() => {
        if (custom_audiences?.length) {
            dispatch({type: "MARK_STEP_COMPLETE", payload: {step_id: "step4", substep_id: "substep41"}})
        } else {
            dispatch({type: "MARK_STEP_INCOMPLETE", payload: {step_id: "step4", substep_id: "substep41"}})
        }
    }, [custom_audiences])

    const render_audience_already_created = () => {
        const latest_audience = custom_audiences[0]

        return (<div className="tw-w-full tw-h-128 tw-space-y-2">
            <p>Congratulation, you have created a custom audience</p>
            <div className="tw-flex tw-flex-col tw-space-y-2">
                <Show_lastest_custom_audience_block audience={latest_audience} />
                { custom_audiences?.length > 1 ? <Link to="/custom-audiences/" className="tw-text-blue-600" target="_blank" rel="noopener noreferrer">View all created custom audiences <FontAwesomeIcon icon={faExternalLink} className="tw-me-2" aria-hidden="true"/></Link> : null}
            </div>
        </div>)
    }

    const skip_click = () => {
        dispatch({type: "MARK_STEP_COMPLETE", payload: {step_id: "step4", substep_id: "substep41"}})
        dispatch({type: "NEXT_STEP"})
    }

    return (
        <C.Eres_card className="tw-overflow-x-auto">
            <div className="tw-m-2 md:tw-m-3">
                <C.Eres_header2xl>Custom audience</C.Eres_header2xl>
                <C.Eres_hline className="tw-m-3" />
                <div className="tw-flex tw-justify-end tw-mb-2">
                    <C.Eres_iconbutton onClick={skip_click}>Skip this step</C.Eres_iconbutton>
                </div>
                <div className="tw-h-min">
                    { custom_audiences?.length ? render_audience_already_created() : <Create_custom_audience_form /> }
                </div>
            </div>
        </C.Eres_card>
    )
}


const Show_lastest_audience_block = ({audience}: {audience : audience_t}) => {
    const [brands, ps, cs] = P.use_brands()
    const detail_url = `/audiences/${audience.id}/`

    return (
        <Link to={detail_url} target="_blank" rel="noopener noreferrer">
            <div className="tw-flex tw-items-center tw-border tw-p-2 tw-justify-between tw-gap-2 tw-min-w-0">
                <div className="tw-space-y-0.5 tw-min-w-0 tw-flex-1">
                    <C.Eres_headerlg className="tw-truncate">{audience.name}</C.Eres_headerlg>
                    <p className="tw-text-sm tw-truncate">Associated brand: <span className="tw-font-semibold">{display_brand_name(brands, audience)}</span></p>
                    <div className="tw-flex tw-flex-wrap tw-gap-x-2 tw-gap-y-1 tw-items-center">
                        <p className="tw-text-sm tw-whitespace-nowrap">Networks: </p>
                        {display_network_on_audience(audience)}
                    </div>
                    <p className="tw-text-xs tw-truncate">{display_estimated_audience_range(audience)}</p>
                </div>
                <div className="tw-shrink-0">
                    <FontAwesomeIcon icon={faArrowUpRightFromSquare} aria-hidden="true" className="tw-ps-1.5"/>
                </div>
            </div>
        </Link>
    )
}


const Saved_audience_creation_component = () => {
    const [ _, dispatch ] = useOnboardingContext();
    P.run_once_on_component_creation(() => void P.poll_saved_audiences(ps, cs))
    const [saved_audiences, ps, cs] = P.use_saved_audiences()

    useEffect(() => {
        if (saved_audiences?.length) {
            dispatch({type: "MARK_STEP_COMPLETE", payload: {step_id: "step4", substep_id: "substep42"}})
        } else {
            dispatch({type: "MARK_STEP_INCOMPLETE", payload: {step_id: "step4", substep_id: "substep42"}})
        }
    }, [saved_audiences])

    const render_audience_already_created = () => {
        const latest_audience = saved_audiences[0]

        return (<div className="tw-w-full tw-h-128 tw-space-y-2">
            <p>Congratulation, you have created a saved audience</p>
            <div className="tw-flex tw-flex-col tw-space-y-2">
                <Show_lastest_audience_block audience={latest_audience} />
                { saved_audiences?.length > 1 ? <Link to="/audiences/" className="tw-text-blue-600" target="_blank" rel="noopener noreferrer">View all created audiences <FontAwesomeIcon icon={faExternalLink} className="tw-me-2" aria-hidden="true"/></Link> : null}
            </div>
        </div>)
    }

    const skip_click = () => {
        dispatch({type: "MARK_STEP_COMPLETE", payload: {step_id: "step4", substep_id: "substep42"}})
        dispatch({type: "NEXT_STEP"})
    }

    return (
        <C.Eres_card className="tw-overflow-x-auto">
            <div className="tw-m-2 md:tw-m-3">
                <C.Eres_header2xl>Saved audience</C.Eres_header2xl>
                <C.Eres_hline className="tw-m-3" />
                <div className="tw-flex tw-justify-end tw-mb-2">
                    <C.Eres_iconbutton onClick={skip_click}>Skip this step</C.Eres_iconbutton>
                </div>
                <div className="tw-h-min">
                    { saved_audiences?.length ? render_audience_already_created() : <Create_audience_form /> }
                </div>
            </div>
        </C.Eres_card>
    )
}

/******************************************************************************
** Step 4 Audience creation ]
******************************************************************************/


/******************************************************************************
** Step 5 Create first campaign [
******************************************************************************/
const Create_first_campaign_component = () => {
    const [ _, dispatch ] = useOnboardingContext();
    P.run_once_on_component_creation(() => void P.poll_creatives(ps, cs))
    const [creatives, ps, cs] = P.use_creatives()

    useEffect(() => {
        if (creatives?.length) {
            dispatch({type: "MARK_STEP_COMPLETE", payload: {step_id: "step5", substep_id: "substep51"}})
        } else {
            dispatch({type: "MARK_STEP_INCOMPLETE", payload: {step_id: "step5", substep_id: "substep51"}})
        }
    }, [creatives, dispatch])

    const render_creative_already_created = () => {
        return (<>
            <C.Eres_header2xl>Eres Campaign</C.Eres_header2xl>
            <p>Congratulation, you have created a campaign(s)</p>
            <div className="tw-w-full tw-overflow-x-scroll" >
                {/* <Saved_audiences_table audiences={saved_audiences} /> */}
            </div>
        </>)
    }

    return (
        <C.Eres_card className="tw-overflow-x-auto">
            <div className="tw-m-2 md:tw-m-3">
                <C.Eres_header2xl>Campaign Creation</C.Eres_header2xl>
                <C.Eres_hline className="tw-m-3" />
                <div className="tw-h-min">
                    {/* { creatives?.length ? render_creative_already_created() : <Create_campaign_form /> } */}
                    <MqttInitializer>
                        <MultistepCreateCampaignProvider in_wizard_mode={true}>
                            <Create_campaign_form />
                        </MultistepCreateCampaignProvider>
                    </MqttInitializer>
                    <C.Eres_collapse title="View video instruction">
                        <YouTube videoId="o-ACY99hrhc" opts={{width: '100%'}} className="tw-w-full tw-mx-auto"/>
                    </C.Eres_collapse>
                </div>
            </div>
        </C.Eres_card>
    )
}
/******************************************************************************
** Step 5 Create first campaign ]
******************************************************************************/

const substep_components: {[key: string]: JSX.Element} = {
    "substep11": <Oauth_integration_step />,
    "substep12": <Asset_syncing_and_verification_step />,
    "substep21": <Meta_pixel_instruction />,
    "substep22": <Linkedin_insight_tag_instruction />,
    "substep23": <Tiktok_pixel_instruction />,
    "substep31": <Brand_creation_component />,
    "substep41": <Custom_audience_creation_component />,
    "substep42": <Saved_audience_creation_component />,
    "substep51": <Create_first_campaign_component />
};

export const Onboarding_section = ({step, active_step_id, on_step_click} : {step: StepData, active_step_id: string, on_step_click: (step_id : string) => void}) => {

    const on_click = (substep_id: string) => {
        return () => {
            on_step_click(substep_id)
        }
    }

    const is_substep_active = (id: number) => id === active_step_id ? "tw-bg-blue-100 tw-font-semibold" : "tw-border-gray-500" 

    return (
        <div>
            <div className="tw-flex tw-items-center tw-p-2 tw-rounded-md tw-mb-2">
                <span className={`tw-flex tw-items-center tw-justify-center tw-w-7 tw-h-7 tw-me-2 tw-text-sm tw-border tw-rounded-full tw-shrink-0 tw-border-blue-600`}>
                    {step.order}
                </span>

                <label className="tw-font-semibold tw-text-big-stone-900">{step.name}</label>
            </div>
            <div className="tw-ml-8">
                <ol className="tw-list-decimal tw-list-inside tw-space-y-2">
                    {step.substeps.map((substep: Substep) => {
                        return (
                            <li key={substep.id} className={`tw-cursor-pointer tw-flex tw-items-center ${is_substep_active(substep.id)}`} onClick={on_click(substep.id)}>
                                <span className="tw-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-me-2 tw-text-xs tw-border tw-border-blue-500 tw-rounded-full tw-shrink-0">
                                    {substep.status === "complete" && <FontAwesomeIcon className="tw-text-green" icon={faCheck}/>}
                                </span>
                                {substep.name}
                            </li>
                        )
                    })}
                </ol>
            </div>
        </div>
    )
}


const Progress_component = () => {
    const [ state, dispatch ] = useOnboardingContext();
    const {current_step, steps} = state;

    // count total substeps and completed substeps
    const total_substeps = steps.reduce((acc, step) => acc + step.substeps.length, 0);
    const completed_substeps = steps.reduce((acc, step) => {
        return acc + step.substeps.filter(substep => substep.status === "complete").length;
    }, 0);

    const progress = total_substeps > 0 ? Math.floor((completed_substeps / total_substeps) * 100) : 0;

    return (
        <div className="tw-mx-auto tw-mb-8 tw-w-full md:tw-w-2/3">
            <div className="tw-flex tw-justify-between tw-mb-1">
                <span className="tw-text-sm md:tw-text-base tw-font-medium tw-text-blue-700 tw-dark:text-white">Progress</span>
                <span className="tw-text-xs md:tw-text-sm tw-font-medium tw-text-blue-700 tw-dark:text-white">{progress}%</span>
            </div>
            <div className="tw-w-full tw-bg-gray-200 tw-rounded-full tw-h-2.5 tw-dark:bg-gray-700">
                <div className="tw-bg-blue-600 tw-h-2.5 tw-rounded-full" style={{width: `${progress}%`}}></div>
            </div>
        </div>
    )
}

const post_data_to_backend = async (state: Onboarding_context_type, token: string) => {
    if (state === undefined) {
        return
    }
    await P.issue_json_post(P.v1api`user/me/wizard-state`, state, z.unknown(), token)
}


export const Onboarding_page = () => {
    const [ps, cs] = P.use_authenticated_program_state()
    const [ state, dispatch ] = useOnboardingContext();

    useEffect(() => {
        const timer = setTimeout(() => {
            post_data_to_backend(state, cs.token)
        }, 500)
        return () => clearTimeout(timer)
    }, [state, cs.token]);

    if (state === undefined) {
        return <p>Context is null</p>
    } else {
        const on_step_click = (step_id : string) => {
            dispatch({type: "SET_ACTIVE_STEP", payload: step_id})
        }
    
        const on_next_click = () => {
            dispatch({type: "NEXT_STEP"})
        }
    
        const on_previous_click = () => {
            dispatch({type: "PREVIOUS_STEP"})
        }

        return (
            <div className="tw-p-2 md:tw-p-4 tw-h-auto tw-max-w-screen-2xl tw-mx-auto">
                <div className="tw-p-2">
                    <h1 className="tw-text-xl md:tw-text-2xl tw-font-bold tw-mb-4">Welcome to onboarding</h1>
                    <p className="tw-text-base md:tw-text-lg tw-mb-4">This onboarding guide will walk you through setting up your account and creating your first campaign.</p>
                    <Progress_component />
                    <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-2 md:tw-gap-4 tw-mb-4">
                        <div className="tw-w-full md:tw-w-2/5 lg:tw-w-1/3 tw-py-4 lg:tw-sticky lg:tw-top-0 tw-flex tw-flex-col">
                            <div className="tw-flex-1">
                                {/* this is each menu content */}
                                {state.steps.map((step: StepData) => {
                                    return (
                                        <Onboarding_section key={step.id} step={step} active_step_id={state.current_step} on_step_click={on_step_click} />
                                    )
                                }
                                )}
                            </div>
                            {/* Navigation buttons at bottom of sidebar on desktop, below content on mobile */}
                            <div className="tw-hidden md:tw-flex tw-flex-col tw-gap-2 tw-mt-4">
                                <C.Eres_iconbutton id="f-save" icon={faCircleChevronLeft} type="submit" onClick={on_previous_click}>Previous</C.Eres_iconbutton>
                                <C.Eres_iconbutton id="f-save" icon={faCircleChevronRight} type="submit" onClick={on_next_click}>Next</C.Eres_iconbutton>
                            </div>
                        </div>
                        <div className="tw-w-full md:tw-w-3/5 lg:tw-w-2/3 tw-h-min">
                            {substep_components[state.current_step]}
                        </div>
                    </div>
                    {/* Mobile navigation buttons - fixed at bottom */}
                    <div className="md:tw-hidden tw-flex tw-flex-row tw-gap-2 tw-sticky tw-bottom-0 tw-bg-white tw-py-4 tw-border-t tw-border-gray-200">
                        <C.Eres_iconbutton icon={faCircleChevronLeft} className="tw-flex-1" type="submit" onClick={on_previous_click}>Previous</C.Eres_iconbutton>
                        <C.Eres_iconbutton icon={faCircleChevronRight} className="tw-flex-1" type="submit" onClick={on_next_click}>Next</C.Eres_iconbutton>
                    </div>
                </div>
            </div>
        )
    }

}


export default function Onboarding() {
    return (
        <Emit_main page_id="PAGE-onboarding">
            <OnboardingContextProvider>
                <Onboarding_page />
            </OnboardingContextProvider>
        </Emit_main>
    )
}

export const Wizard = Onboarding
export const Wizard_page = Onboarding_page
export const WizardContextProvider = OnboardingContextProvider
